import _, {reduce} from 'lodash'
import React from 'react'
import {connect} from 'react-redux'
import Menu from 'antd/lib/menu'
import Layout from 'antd/lib/layout'
import Icon from 'antd/lib/icon'

import {withRouter} from 'react-router-dom'
import Link from 'components/CustomComponents/Localization/Link'
import ReferralLink from 'components/CustomComponents/Link/ReferralLink'
import {logout} from 'ducks/login'
import {getCurrentUser, setActiveDialog, setLayoutState} from 'ducks/app'
import {sendVideoIntroductionEvent, sendVideoLessonEvent} from 'ducks/analytics'
import renderHTML from 'react-render-html'
import {Scrollbars} from 'react-custom-scrollbars'
import './style.scss'
import l8n, {prefixPath} from 'l8n'

const {Sider} = Layout
const SubMenu = Menu.SubMenu
const Divider = Menu.Divider

const mapStateToProps = (state, props) => {
  return {
    pathname: state.routing.location.pathname,
    collapsed: state.app.layoutState.menuCollapsed,
    activeDialog: state.app.activeDialog,
    user: getCurrentUser(state),
    logAsEnabled: state.app.logAs.enabled
  }
}

@connect(mapStateToProps)
@withRouter
class MenuLeft extends React.Component {
  state = {
    pathname: this.props.pathname,
    collapsed: this.props.collapsed,
    selectedKeys: '',
    openKeys: [''],
    activeDialog: this.props.activeDialog
  }

  handleClick = e => {
    const { dispatch, isMobile } = this.props
    if (isMobile) {
      // collapse menu on isMobile state
      dispatch(setLayoutState({ menuMobileOpened: false }))
    }
    // set current selected keys
    this.setState({
      selectedKeys: e.key
    })
  }

  onOpenChange = openKeys => {
    this.setState({ openKeys })
  }

  getPath(data, id, parents = []) {
    const { selectedKeys } = this.state
    let items = reduce(
      data,
      (result, entry) => {
        if (result.length) {
          return result
        } else if (prefixPath(entry.url, l8n.locale) === id && selectedKeys === '') {
          return [entry].concat(parents)
        } else if (entry.key === id && selectedKeys !== '') {
          return [entry].concat(parents)
        } else if (entry.children) {
          let nested = this.getPath(entry.children, id, [entry].concat(parents))
          return nested ? nested : result
        }
        return result
      },
      [],
    )
    return items.length > 0 ? items : false
  }

  getActiveMenuItem = (props, items) => {
    const { selectedKeys, pathname } = this.state
    let { collapsed } = props
    let [activeMenuItem, ...path] = this.getPath(items, !selectedKeys ? pathname : selectedKeys)

    if (collapsed) {
      path = ['']
    }

    this.setState({
      selectedKeys: activeMenuItem ? activeMenuItem.key : '',
      openKeys: activeMenuItem ? path.map(entry => entry.key) : [],
      collapsed,
    })
  }

  generateMenuPartitions(items) {
    return items.map(menuItem => {
      if (menuItem.children) {
        let subMenuTitle = (
          <span className="menuLeft__title-wrap" key={menuItem.key}>
            <span className="menuLeft__item-title" data-qa-id="menu-left-site-title">{menuItem.title}</span>
            {menuItem.icon && <Icon type={menuItem.icon}/>}
          </span>
        )
        return (
          <SubMenu title={subMenuTitle} key={menuItem.key}>
            {this.generateMenuPartitions(menuItem.children)}
          </SubMenu>
        )
      }
      return this.generateMenuItem(menuItem)
    })
  }

  generateMenuItem(item) {
    const { key, title, url, icon, disabled, click, color, qa_key } = item
    const { dispatch } = this.props
    const qaId = 'menu-left-' + (qa_key ? qa_key : key) + '-link'
    const props = {
      to: url,
      onClick: this.props.isMobile ? 
        () => {
          dispatch(setLayoutState({ menuCollapsed: false }))
          click()
        }
        : 
        click
    }

    if (item.hide) {
      return;
    }

    return item.divider ? (
      <Divider key={Math.random()} />
    ) : item.url ? (
      <Menu.Item key={key} disabled={disabled}>
        {
          item.url_force ?
            <a href={props.to} onClick={props.onClick} target={!!item.blank ? '_blank' : ''} data-qa-id={qaId}>
              <span className="menuLeft__item-title" style={{ color }}>{title}</span>
              {icon && <Icon type={icon} style={{ color }} />}
            </a>
            :
            <Link 
              to={url}
              qaId={qaId}
              onClick={props.onClick}
            >
              <span className="menuLeft__item-title" style={{ color }}>{title}</span>
              {icon && <Icon type={icon} style={{ color }} />}
            </Link>
        }
      </Menu.Item>
    ) : (
      <Menu.Item key={key} disabled={disabled} onClick={click}>
        <span className="menuLeft__item-title" data-qa-id={qaId} style={{ color }}>{title}</span>
        {icon && <Icon type={icon} style={{ color }} />}
      </Menu.Item>
    )
  }

  onCollapse = (value, type) => {
    const { dispatch } = this.props
    const { collapsed } = this.state
    if (type === 'responsive' && collapsed) {
      return
    }
    dispatch(setLayoutState({ menuCollapsed: !collapsed }))
  }

  generateMenuArray = (props, l8n) => {
    return [
      {
        title: props.logAsEnabled ? 
          <span style={{ color: 'green', fontWeight: 600 }}>{props.user.display_name}</span> 
          : 
          <span style={{ fontWeight: 600 }}>{props.user.display_name}</span>,
        key: 'user',
        url: false,
        icon: 'user',
        children: [
          {
            title: l8n.p_settings,
            key: 'settings',
            url: '/settings',
            icon: 'setting',
          },
          {
            title: l8n.p_logout,
            key: 'logout',
            url: false,
            icon: 'logout',
            color: '#f5222d',
            click: () => {
              props.dispatch(logout())
            }
          },
        ]
      },
      {
        title: l8n.p_accounting,
        key: 'details',
        url: '/details',
        icon: 'bank'
      },
      { divider: true },
      {
        title: l8n.p_dashboard,
        key: '/',
        url: '/',
        icon: 'stock',
        qa_key: 'main' 
      },
      {
        title: l8n.p_customers,
        key: 'customers',
        url: '/customers',
        icon: 'team'
      },
      {
        title: l8n.p_payments,
        key: 'payments',
        url: '/payments',
        icon: 'wallet'
      },
      {
        title: l8n.p_reward,
        key: 'withdrawals',
        url: '/withdrawals',
        icon: 'dollar'
      },
      { divider: true },
      {
        title: l8n.p_new_client,
        key: 'add_client',
        url: `https://${props.user.app_host}/signup.html?partner_id=${props.user.id}&lang=${l8n.locale}&pricelist_id=${props.user.pricelist_id}`,
        icon: 'plus',
        url_force: true,
        blank: true
      },
      {
        title: <ReferralLink/>,
        key: 'referral_link',
        url: false,
        icon: 'link',
        click: () => {
          props.dispatch(setActiveDialog('referral_link'))
        }
      },
      {
        title: l8n['integration.title'],
        key: 'integration_api',
        url: '/integration',
        icon: 'interaction',
      },
      {
        title: l8n['video_intro.title'],
        key: 'video_intro',
        url: 'https://www.youtube.com/playlist?list=PLKaVPKorKJC3veVRvJ7BTSFL8i8Kl2DO2',
        url_force: true,
        blank: true,
        icon: 'youtube',
        hide: l8n.locale !== 'ru',
        color: '#f5222d',
        click: () => {
          sendVideoIntroductionEvent(props.user)
        }
      },
      {
        title: l8n['video_lesson.title'],
        key: 'video_lesson',
        url: 'https://www.youtube.com/playlist?list=PLKaVPKorKJC0xBX94u50eYfSZjDFCYf0X',
        url_force: true,
        blank: true,
        icon: 'youtube',
        hide: l8n.locale !== 'ru',
        color: '#f5222d',
        click: () => {
          sendVideoLessonEvent(props.user)
        }
      },
      {
        title: l8n.p_marketingDocuments,
        key: 'marketing_documents',
        url: `https://files.jivosite.com/partner/marketing/${l8n.locale.toUpperCase()}.zip`,
        icon: 'file-pdf',
        url_force: true,
        blank: true
      },
      {
        title: l8n.p_advertising_requirements,
        key: 'advertising_requirements',
        url: `https://files.jivosite.com/partner/marketing/advertising_${l8n.locale}.pdf`,
        icon: 'file-pdf',
        url_force: true,
        blank: true
      },
      { divider: true },
      {
        title: l8n.localeNames[l8n.locale],
        key: 'locale',
        url: false,
        icon: 'global',
        children: _.filter(
          _.keys(l8n.locales).map(function(locale){
            if (locale !== l8n.locale){
              return {
                title: l8n.localeNames[locale],
                key: 'locale_' + locale,
                url: prefixPath('/', locale),
                url_force: true
              }
            }
          })
        )
      }
    ]
  
  }

  componentDidMount() {
    const menuData = this.generateMenuArray(this.props, l8n)
    this.getActiveMenuItem(this.props, menuData)
  }

  componentWillReceiveProps(newProps) {
    const menuData = this.generateMenuArray(this.props, l8n)
    this.setState(
      {
        selectedKeys: '',
        pathname: newProps.pathname,
        collapsed: newProps.collapsed
      },
      () => {
        if (!newProps.isMobile) {
          this.getActiveMenuItem(newProps, menuData)
        }
      }
    )
  }

  render() {
    const { collapsed, selectedKeys, openKeys } = this.state
    const { isMobile } = this.props
    const menuData = this.generateMenuArray(this.props, l8n)
    const menuItems = this.generateMenuPartitions(menuData)
    const paramsMobile = {
      width: 256,
      collapsible: false,
      collapsed: false,
      onCollapse: this.onCollapse,
    }
    const paramsDesktop = {
      width: 256,
      collapsible: true,
      collapsed: collapsed,
      onCollapse: this.onCollapse,
      breakpoint: 'lg',
    }
    const params = isMobile ? paramsMobile : paramsDesktop
    const logoPathName = `/resources/images/logo/${l8n.locale === 'ru' ? '168x54/jivo' : '185x54/jivochat'}_white.svg`

    return (
      <Sider {...params} className="menuLeft">
        <div className={`menuLeft__logo ${params.collapsed ? 'menuLeft__logoCollapsed' : ''}`}>
          <Link to={'/'} className="menuLeft__logoContainer">
            <img className="menuLeft__logoImg" src={logoPathName}/>
            <div className="menuLeft__logoTitle">{l8n.locale === 'en' || l8n.locale === 'id' ? renderHTML(l8n.p_affiliate_program.split(' ').join('<br/>')) : l8n.p_affiliate_program}</div>
          </Link>
        </div>
        <Scrollbars
          autoHide
          style={{ height: isMobile ? 'calc(100vh - 64px)' : (params.collapsed ? 'calc(100vh)' : 'calc(100vh - 131px)') }}
        >
          <Menu
            onClick={this.handleClick}
            selectedKeys={[selectedKeys]}
            openKeys={openKeys}
            onOpenChange={this.onOpenChange}
            mode="inline"
            className="menuLeft__navigation"
          >
            {menuItems}
          </Menu>
        </Scrollbars>
      </Sider>
    )
  }
}

export default MenuLeft



// WEBPACK FOOTER //
// ./src/components/CustomComponents/Layout/MenuLeft/index.js